import { takeEvery, all, select, put } from 'redux-saga/effects';
import { selectedPostAcqTaskSelector, postAcqUWStateSelector, userRoleUnderwriteManagerSelector } from 'store/selectors';
import {
  savePostAcqModuleUW,
  setPostAcqSelectedValuation,
  setPostAcqTransientValuation,
  appNotify,
  setIsSavingPostAcqUW,
  setPostAcqWorkflowLoadingOverlayState,
  setPostAcqSelectedProformaInputsContainer,
  setErrorListModalState,
  afterSavePostAcqUWNavigate,
  setPostAcqSelectedTaskHistory,
  fetchPostAcqTaskHistory
} from 'store/actions';
import { postWithTokenV2 } from 'api/network';
import { sendClientLog } from 'services/logService';
import { Constants } from 'utilities/constants';

export function* savePostAcqUWSaga() {
  yield takeEvery(savePostAcqModuleUW, function* ({ payload }) {
    const { taskId, transientValuation, history, nextTaskId, afterNavigation, callback } = payload;
    yield put(setIsSavingPostAcqUW(true));
    yield put(setPostAcqWorkflowLoadingOverlayState({ isLoading: true, message: 'Saving...' }));

    try {
      const { id, notes, valuationInput, valuationsComps } = transientValuation;
      console.log(transientValuation)
      const {
        rent,
        rentType,
        afterRepairValue,
        afterRepairValueType,
        lotValue,
        lotValueType,
        asIsValue,
        asIsValueType,
        reducedRent,
        reducedRentType,
        reducedAfterRepairValue,
        reducedAfterRepairValueType
      } = valuationInput;
      const req = {
        id,
        valuationInput: {
          rent,
          rentType,
          afterRepairValue,
          afterRepairValueType,
          lotValue,
          lotValueType,
          asIsValue,
          asIsValueType,
          reducedRent,
          reducedRentType,
          reducedAfterRepairValue,
          reducedAfterRepairValueType
        },
        notes,
        valuationsComps
      };
      // console.log(req)

      const newReq = {
        taskId,
        valuation: {
          postAcquisitionLoadInstanceId: transientValuation.postAcquisitionLoadInstanceId,
          notes,
          rent,
          rentType,
          afterRepairValue,
          afterRepairValueType,
          lotValue,
          lotValueType,
          asIsValue,
          asIsValueType,
          reducedRent,
          reducedRentType,
          reducedAfterRepairValue,
          reducedAfterRepairValueType,
          takenValuationId: transientValuation.takenValuationId
        },
        compIds: valuationsComps.map(comp => comp.compId)
      }
      const persistedValuationData = yield postWithTokenV2(`/api/postAcquisition/tasks/save/valuation`, newReq);

      const { selectedProformaInputsContainer } = yield select(postAcqUWStateSelector);
      const persistedValuationMapped = {
        createdOn: persistedValuationData.valuation.createdOn,
        id: persistedValuationData.valuation.id,
        userId: persistedValuationData.valuation.createdBy
      }

      let updatedValuation = null;
      const newValuations = selectedProformaInputsContainer.valuations.map(val => {
        if (val.user.id === persistedValuationMapped.userId) {
          updatedValuation = {
            ...val,
            ...req,
            id: persistedValuationMapped.id,
            createdOn: persistedValuationMapped.createdOn
          };
          return updatedValuation;
        }
        return val;
      });

      yield all([
        put(setPostAcqSelectedProformaInputsContainer({
          ...selectedProformaInputsContainer,
          valuations: newValuations
        })),
        put(setPostAcqSelectedValuation(updatedValuation)),
        put(setPostAcqTransientValuation(updatedValuation)),
      ]);

      yield put(appNotify('Saved Underwrite', 'success', { autoHideDuration: 1500 }));

      yield put(setIsSavingPostAcqUW(false));
      yield put(setPostAcqWorkflowLoadingOverlayState({ isLoading: false, message: null }));

      if (nextTaskId) {
        history.push(`${Constants.Routes.POSTACQ_TASK}/${nextTaskId}`);
      }

      if (afterNavigation) {
        yield put(afterSavePostAcqUWNavigate({ history, ...afterNavigation }))
      }

      // Task History is Underwrite Manager–only; the user is always loaded by save time.
      if (nextTaskId == null && !afterNavigation && (yield select(userRoleUnderwriteManagerSelector))) {
        const task = yield select(selectedPostAcqTaskSelector);
        function* taskHistoryCallback(taskHistory) {
          yield put(setPostAcqSelectedTaskHistory(taskHistory));
        }
        yield put(fetchPostAcqTaskHistory(task.id, taskHistoryCallback))
      }

      if (callback) {
        callback();
      }

      sendClientLog('Info', `Frontend recieved saved post-acq valuation with id: ${updatedValuation?.id}`);
    } catch (error) {
      yield put(setIsSavingPostAcqUW(false));
      yield put(setPostAcqWorkflowLoadingOverlayState({ isLoading: false, message: null }));

      const { details } = error
      if (!details) {
        console.log(error)
        yield put(appNotify(error.message, 'error'));
        return;
      }

      if (details.length === 1) {
        const [firstDetails] = details
        yield put(appNotify(firstDetails, 'error'));
      } else {
        yield put(setErrorListModalState({ header: 'Unable to save valuation for the following reasons', details }))
        const options = { showDetailsButton: true }
        yield put(appNotify('Unable to save valuation', 'error', options));
      }
    }
  });
}

const getPayload = (transientValuation, defaultValue) => {
  if (!defaultValue) {
    return transientValuation
  }

  const updatedTransientValuation = { ...transientValuation, type: defaultValue }
  return updatedTransientValuation
}